import Vue from 'vue';
import 'es6-promise/auto'
import store from './store'
import i18n from './VueI18n'

import SidebarVue from'./filter/sidebar'
import TopbarVue from'./filter/topbar'

class Filter {
    constructor(appId) {
        this.app = new Vue({
            el: appId,
            store,
            i18n,
            components: {
                sidebar: SidebarVue,
                topbar: TopbarVue,
            }
        });
    }
}

export default Filter;
